import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import type { AnnouncementCardProps } from './type'

import { formatDate } from '@/utils/date'

import { ANNOUNCEMENT_BADGE_CLASSES, ANNOUNCEMENT_TAG_MAP } from '../const'

export const AnnouncementCard = ({
  title,
  displayDate,
  tag,
}: AnnouncementCardProps) => {
  const { t } = useTranslation()
  const tagMeta = ANNOUNCEMENT_TAG_MAP[tag]

  return (
    <div className={clsx('tw-text-sm', 'tw-flex tw-flex-col tw-gap-2')}>
      <div className={clsx('tw-flex tw-flex-wrap tw-items-center tw-gap-2')}>
        <span
          className={clsx(
            'tw-inline-block tw-rounded-full tw-px-2 tw-py-0.5',
            'tw-text-2xs tw-font-bold',
            ANNOUNCEMENT_BADGE_CLASSES[tagMeta.badgeVariant]
          )}
        >
          {t(tagMeta.labelKey)}
        </span>
        <span className={clsx('tw-text-gray-600')}>
          {formatDate(displayDate, 'yyyy-MM-dd')}
        </span>
      </div>
      <div className={clsx('tw-font-bold')}>{title}</div>
      <div className={clsx('tw-text-primary-500 tw-underline')}>
        {t('announcement.viewDetails')}
      </div>
    </div>
  )
}
